import React, { useState } from 'react';
import { Select, Button, message } from 'antd';
import { PencilIcon } from '@heroicons/react/24/outline';


const { Option } = Select;

const AIRewriter = ({ onClose, onRewrite }) => {
  const [selectedOption, setSelectedOption] = useState('');
  const [customRows, setCustomRows] = useState([]);
  const [isRewriting, setIsRewriting] = useState(false);

  const handleOptionChange = (value) => {
    setSelectedOption(value);
    if (value !== 'custom') {
      setCustomRows([]);
    }
  };

  const handleCustomRowChange = (value) => {
    setCustomRows(value);
  };

  const handleRewrite = async () => {
    setIsRewriting(true);
    message.loading('AI Rewriting in progress...', 0);
    
    try {
      await onRewrite(selectedOption, customRows);
      message.destroy();
      message.success('AI Rewriting completed successfully');
      onClose();
    } catch (error) {
      message.destroy();
      message.error('AI Rewriting failed. Please try again.');
    } finally {
      setIsRewriting(false);
    }
  };

  return (
    <div className="space-y-6">
      <h2 className="text-2xl font-bold mb-4">AI Rewriter</h2>
      <div>
        <label className="block text-sm font-medium text-gray-700 mb-1">
          Select rows to rewrite
        </label>
        <Select
          style={{ width: '100%' }}
          value={selectedOption}
          onChange={handleOptionChange}
          placeholder="Choose an option"
        >
          <Option value="custom">Custom Rows</Option>
          <Option value="empty">Rows with Empty AI Rewritten Text</Option>
          <Option value="all">All Rows</Option>
        </Select>
      </div>

      {selectedOption === 'custom' && (
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-1">
            Select specific rows to rewrite
          </label>
          <Select
            mode="multiple"
            style={{ width: '100%' }}
            placeholder="Choose rows"
            onChange={handleCustomRowChange}
            value={customRows}
          >
            {/* Assuming you have row numbers, adjust as needed */}
            {[1, 2, 3, 4, 5, 6].map(row => (
              <Option key={row} value={row}>{row}</Option>
            ))}
          </Select>
        </div>
      )}

      <div className="flex justify-end">
        <Button
          onClick={handleRewrite}
          disabled={!selectedOption || (selectedOption === 'custom' && customRows.length === 0) || isRewriting}
          className="inline-flex items-center px-4 py-2 border border-transparent text-sm font-medium rounded-md shadow-sm text-white bg-blue-600 hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500"
        >
          <PencilIcon className="h-5 w-5 mr-2" />
          {isRewriting ? 'Rewriting...' : 'Rewrite Selected Rows'}
        </Button>
      </div>
    </div>
  );
};

export default AIRewriter;
